import React, { useRef } from "react";
import Home from "../pages/home";
import { useGLTF, Html } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { useState, useEffect } from "react";

function Desktop(props) {
  const [computerIsOn, setComputerIsOn] = React.useState(false);
  const group = useRef();
  const { nodes, materials } = useGLTF("/3d_objects/low_poly_gaming_desk.glb");
  const [opacity, setOpacity] = React.useState(0);
  const [isScreenHovered, setIsScreenHovered] = useState(false);
  useEffect(() => {
    setComputerIsOn(true);
  }, []);

  useEffect(() => {
    if (isScreenHovered && !props.onScreen) {
      document.body.style.cursor = "pointer";
    } else {
      document.body.style.cursor = "default";
    }
  }, [isScreenHovered, props.onScreen]);

  const handleBackgroundClick = () => {
    if (props.onScreen) {
      props.setOnScreen(false);
    }
  };

  React.useEffect(() => {
    props.setLoading(props.loading + 1);
  }, [nodes]);

  React.useEffect(() => {
    props.loading === 3 &&
      setTimeout(() => {
        setComputerIsOn(true);
      }, 500);
  }, [props.loading]);

  useFrame((state, delta) => {
    if (!computerIsOn) {
      const time = state.clock.getElapsedTime();
      setOpacity(0.7 + 0.5 * Math.sin(time * 2.5));
    } else {
      setOpacity(1);
    }
  });

  return (
    <group ref={group} {...props} dispose={null}>
      {props.onScreen && (
        <mesh position={[0.4, 4.66, -1]} onClick={handleBackgroundClick}>
          <planeGeometry args={[20, 10]} />
          <meshBasicMaterial transparent opacity={0.01} />
        </mesh>
      )}
      <group>
        <group>
          <mesh
            material={materials["Plastic"]}
            geometry={nodes["Object_4"].geometry}
            scale={[1.45, 1, 1.15]}
          />
          <mesh
            material={materials["Material.003"]}
            geometry={nodes["Object_5"].geometry}
            scale={[1.4, 1, 1.15]}
          />
          <group scale={[0.6, 0.12, 0.4]} position={[0.4, 3.4, -0.3]}>
            <mesh
              material={materials["matte.001"]}
              geometry={nodes["Object_9"].geometry}
            />
            <mesh
              material={materials.black}
              geometry={nodes["Object_8"].geometry}
              onPointerEnter={() => setIsScreenHovered(true)}
              onPointerLeave={() => setIsScreenHovered(false)}
              onClick={() => props.setOnScreen(true)}
            />
            <mesh
              material={materials.black}
              geometry={nodes["Object_7"].geometry}
              ref={props.screenRef}
              onPointerEnter={() => setIsScreenHovered(true)}
              onPointerLeave={() => setIsScreenHovered(false)}
              onClick={() => props.setOnScreen(true)}
            />
          </group>
          {computerIsOn && (
            <Html
              className="bg-gray-50 w-[1460px] h-[850px] overflow-x-hidden"
              position={[0.4, 4.66, -0.15]}
              transform
              occlude
              rotation={[-0.13, 0, 0]}
              scale={[0.08, 0.08, 0.08]}
            >
              <div onPointerDown={(e) => e.stopPropagation()}>
                <Home />
              </div>
            </Html>
          )}
          <primitive object={nodes.keyboard_4} position={[0.4, 3.315, 1.3]} />
          <primitive object={nodes.mouse_5} position={[2, 3.315, 1.3]} />
          <primitive object={nodes.cpu_6} position={[3, 4.3, 0]} />

          {/* Bouton power avec position stabilisée */}
          <mesh
            position={[3.0, 5.2, 1.05]}
            scale={[0.17, 0.17, 0.17]}
            onClick={() => setComputerIsOn(!computerIsOn)}
            onPointerEnter={() => props.setHovered(true)}
            onPointerLeave={() => props.setHovered(false)}
          >
            <sphereGeometry args={[0.5, 32, 32]} />
            <meshStandardMaterial
              opacity={opacity}
              transparent={true}
              color={computerIsOn ? "#F5F5F5" : "#ff6b6b"}
              emissive={computerIsOn ? "#004400" : "#440000"}
              emissiveIntensity={0.3}
            />
          </mesh>
        </group>
      </group>
    </group>
  );
}

export default Desktop;
